import { useEffect } from 'react'
import { motion } from 'framer-motion'
import Seo from '../components/Seo'

const CRISP_EMBED_URL = 'https://go.crisp.chat/chat/embed/?website_id=eb301baf-025e-4afd-8e05-a2c0c2f8398e'

export default function Contact() {
  useEffect(() => {
    window.$crisp = window.$crisp || []
    window.$crisp.push(['do', 'chat:hide'])

    return () => {
      window.$crisp?.push(['do', 'chat:show'])
    }
  }, [])

  return (
    <div>
      <Seo
        title="Kontakt"
        description="Kontakta Norhill via chatt, e-post eller LinkedIn. Boka en kostnadsfri konsultation eller ställ frågor om IT-arkitektur, rådgivning och coaching."
      />
      <section className="bg-[#dbdad8] section-padding shadow-xl">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-4xl mx-auto text-center"
          >
            <h1 className="text-5xl md:text-6xl font-heading font-bold text-nordic-blue mb-6">
              Kontakta
            </h1>
            <p className="text-xl md:text-2xl text-dark-gray leading-relaxed">
              Chatta med oss direkt, skicka ett mail eller kontakta via LinkedIn – vi återkommer inom 24 timmar.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="container-custom max-w-4xl mx-auto space-y-12">
          {/* Primärt kontaktsätt – Crisp Chat */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="rounded-lg overflow-hidden shadow-xl border-2 border-amber-gold/60 bg-gradient-to-br from-amber-gold/20 via-amber-gold/10 to-white"
          >
            <div className="p-6 md:p-8">
              <div className="inline-flex items-center gap-2 bg-amber-gold rounded-full px-4 py-1.5 mb-4">
                <span className="text-near-black font-heading font-bold text-sm uppercase tracking-wider">
                  Rekommenderat
                </span>
              </div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-near-black mb-3">
                Chatta med oss
              </h2>
              <p className="text-dark-gray leading-relaxed mb-6 max-w-2xl">
                Snabbast svar får du här. Skriv ditt meddelande i chatten nedan så återkommer vi så snart vi kan.
              </p>
              <div className="w-full rounded-lg border border-medium-gray bg-white shadow-md overflow-hidden">
                <iframe
                  src={CRISP_EMBED_URL}
                  title="Norhill chatt"
                  className="block w-full h-[min(600px,calc(100vh-16rem))] min-h-[420px] border-0"
                />
              </div>
            </div>
          </motion.div>

          {/* E-post */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="rounded-lg overflow-hidden shadow-lg border border-medium-gray bg-white"
          >
            <div className="p-6 md:p-8">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-nordic-blue mb-3">
                Kontakta via e-post
              </h2>
              <p className="text-dark-gray leading-relaxed mb-4">
                Skicka gärna ett mail så återkommer vi inom 24 timmar.
              </p>
              <a
                href="mailto:info@norhill.se"
                className="inline-flex items-center gap-2 text-nordic-blue hover:text-forest-green font-heading font-semibold transition-colors"
              >
                info@norhill.se
              </a>
            </div>
          </motion.div>

          {/* LinkedIn */}
          <motion.a
            href="https://www.linkedin.com/company/norhill/"
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.15 }}
            whileHover={{ y: -2 }}
            className="block rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow border border-medium-gray bg-white"
          >
            <div className="p-6 md:p-8">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-nordic-blue mb-3">
                Kontakta via LinkedIn
              </h2>
              <p className="text-dark-gray leading-relaxed mb-6">
                Gå in på Norhills företagssida och använd alternativet &ldquo;Skicka meddelande&rdquo; för att kontakta eller skicka förfrågan.
                Passa även på att följa!
              </p>
              <span className="inline-flex items-center gap-2 btn-primary">
                Till Norhills företagssida
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </span>
            </div>
          </motion.a>
        </div>
      </section>
    </div>
  )
}
